import React, { useEffect, useRef, useState } from "react";

import { Form, FormSelect, Modal, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import img1 from "../images/supplementary_card.png";
import img2 from "../images/duplicate.png";
import removeImg from "../images/remove.png";
import {
  NumbersAndSpecialCharactersRegex,
  getBase64,
  NumbersRegex,
  relationwithApplicant,
  cardlimitpercent,
} from "../utils";
import { axiosInstance } from "../config/axios";
import {
  baseurl,
  supplmentcardUrl,
  termsConditionsUrl,
} from "../utils/apiurls";
import img3 from "../images/logo_mark.png";
import img4 from "../images/back-arrow.png";
import { TermsConditionModal } from "./TermsConditionModal";
import success from "../images/check.png";
import ImageErrorModal from "./ImageErrorModal";

// import { getBase64 } from "../utils";
export const Supplementcard = () => {
  const usertemplet = {
    Name: "",
    cnic: "",
    sourceCode: "",
    cnicfront: "",
    cnicback: "",
    cnicfrontbase64: "",
    cnicbackbase64: "",
    relationshipWithPrimaryApplicant: "",
    cardLimitPercentage: ""
  };
  const [users, setUser] = useState([usertemplet]);
  const [imageSizeErrorModal, setimageSizeErrorModal] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const handleImageErrorModalClose = () => setimageSizeErrorModal(false);
  const [supcardObj, setsupcardCount] = useState({});
  const [loaderBool, setloaderBool] = useState(false);
  const [show, setshow] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const handleClose = () => setshow(false);
  const handleShow = () => setshow(true);
  const location = useLocation();
  const cnicFrontRef = useRef();
  const cnicBackRef = useRef();

  console.log(location.state);

  useEffect(() => {
    if (location?.state) {
      setsupcardCount(location?.state);
    }
    return () => {
      setsupcardCount({});
    };
  }, [location?.state]);

  useEffect(() => {
    if (imageSizeErrorModal) {
      setTimeout(() => {
        setimageSizeErrorModal(false);
      }, 2000);
    }
  }, [imageSizeErrorModal]);

  const adduser = () => {
    if (!addUserValidation()) {
      setUser([...users, usertemplet]);
    } else {
      setimageSizeErrorModal(true);
      setErrorMessage("All fields are mandatory");

    }
  };

  const addUserValidation = () => {
    return users.some(item => {
      return Object.keys(item).some(iter => iter !== "sourceCode" && !item[iter])
    })

  }

  const removeUsers = (index) => {
    const filterdUsers = [...users];
    filterdUsers.splice(index, 1);
    setUser(filterdUsers);
  };

  const checkFileExtension = (val) => {
    const value = val.name.split(".")[val.name.split(".").length - 1].toLowerCase();
    return ["jpeg", "jpg", "png", "pdf"].some((item) => item === value);
  };

  const onChange = async (e, index) => {
    let updatedUser;
    if (e.target.type === "file" && e.target.files[0].size > 2000000) {
      setimageSizeErrorModal(true);
      setErrorMessage("File is too big, Max 2 MB file is acceptable");
      if (e.target.name === "cnicfront") {
        e.target.files = null
        e.target.value = null
      } else {
        e.target.files = null
        e.target.value = null
      }
      updatedUser = users.map((user, i) =>
        index == i ? Object.assign(user, { [e.target.name]: "" }) : user
      );
    }
    else if (e.target.type === "file" && e.target.files[0].size < 1) {
      setimageSizeErrorModal(true);
      setErrorMessage("Empty file are not acceptable");
      if (e.target.name === "cnicfront") {
        e.target.files = null
        e.target.value = null
      } else {
        e.target.files = null
        e.target.value = null
      }
      updatedUser = users.map((user, i) =>
        index == i ? Object.assign(user, { [e.target.name]: "" }) : user
      );
    }
    else if (
      e.target.type === "file" &&
      !checkFileExtension(e.target.files[0])
    ) {
      setimageSizeErrorModal(true);
      setErrorMessage("Only Png, Jpg, Jpeg, Pdf format is allowed.");
      if (e.target.name === "cnicfront") {
        e.target.files = null
        e.target.value = null
      } else {
        e.target.files = null
        e.target.value = null

      }
      updatedUser = users.map((user, i) =>
        index == i ? Object.assign(user, { [e.target.name]: "" }) : user
      );
    } else {
      if (e.target.type === "file") {
        updatedUser = users.map((user, i) =>
          index == i
            ? Object.assign(user, { [e.target.name]: e.target.files })
            : user
        );
        await func(updatedUser, index);
      } else {
        if (
          e.target.name === "Name" &&
          NumbersAndSpecialCharactersRegex(e.target.value)
        ) {
          setimageSizeErrorModal(true);
          setErrorMessage("Number and Special Characters is not allowed.");
          updatedUser = users.map((user, i) =>
            index == i
              ? Object.assign(user, {
                [e.target.name]: e.target.value.substring(
                  0,
                  e.target.value.length() - 1
                ),
              })
              : user
          );
        } else if (e.target.name === "Name" && e.target.value.length > 35) {
          setimageSizeErrorModal(true);
          setErrorMessage("Max 35 Letters allowed");
          updatedUser = users.map((user, i) =>
            index == i
              ? Object.assign(user, {
                [e.target.name]: e.target.value.substring(
                  0,
                  e.target.value.length() - 1
                ),
              })
              : user
          );
        } else if (e.target.name === "cnic" && e.target.value.length > 13) {
          setimageSizeErrorModal(true);
          setErrorMessage("13 Numbers allowed in CNIC");
          updatedUser = users.map((user, i) =>
            index == i
              ? Object.assign(user, {
                [e.target.name]: e.target.value.substring(
                  0,
                  e.target.value.length - 1
                ),
              })
              : user
          );
        } else if (e.target.name === "cnic" && NumbersRegex(e.target.value)) {
          setimageSizeErrorModal(true);
          setErrorMessage("Only Numbers allowed.");
          updatedUser = users.map((user, i) =>
            index == i
              ? Object.assign(user, {
                [e.target.name]: e.target.value.substring(
                  0,
                  e.target.value.length() - 1
                ),
              })
              : user
          );
        } else {
          updatedUser = users.map((user, i) =>
            index == i
              ? Object.assign(user, { [e.target.name]: e.target.value })
              : user
          );
        }
      }
    }

    setUser(updatedUser);
  };

  const func = (user, currentIndex) => {
    if (user[currentIndex]?.cnicfront.length > 0) {
      getBase64(user[currentIndex]?.cnicfront[0]).then((result) => {

        setUser((currentUser) =>
          currentUser.map((user, index) => {
            return currentIndex === index
              ? { ...user, cnicfrontbase64: result }
              : user;
          })
        );
      });
    }
    if (user[currentIndex]?.cnicback.length > 0) {
      getBase64(user[currentIndex]?.cnicback[0]).then((result) => {
        setUser((currentUser) =>
          currentUser.map((user, index) => {
            return currentIndex === index
              ? { ...user, cnicbackbase64: result }
              : user;
          })
        );
      });
    }
  };

  const submitSupplementCard = async (e) => {
    setloaderBool((current) => true);
    e.preventDefault();
    let suplemntList = [];
    suplemntList = users.map((user) => {
      const frontfileExtension = user.cnicfront[0].type.split("/")[1];
      const backfileExtension = user.cnicback[0].type.split("/")[1];
      return {
        cnicNumber: user.cnic,
        fullName: user.Name,
        relationshipWithPrimaryApplicant: user.relationshipWithPrimaryApplicant,
        cardLimitPercentage: user.cardLimitPercentage,
        // sourceCode: supcardObj.sourceCode,
        sourceCode: location?.state?.sourceCode ,

        dtoList: [
          {
            base64: user.cnicfrontbase64.split(
              `data:${user.cnicfront[0].type};base64,`
            )[1],
            name: `${user.cnic}_cnic_front.${frontfileExtension}`,
          },
          {
            base64: user.cnicbackbase64.split(
              `data:${user.cnicback[0].type};base64,`
            )[1],
            name: `${user.cnic}_cnic_back.${backfileExtension}`,
          },
        ],
      };
    });

    const response = await axiosInstance.post(supplmentcardUrl, {
      list: suplemntList,
      id: supcardObj.id,
      moduleId: 0,
      statusId: 0,

    }).catch(err => {
      setloaderBool((current) => false);
      setimageSizeErrorModal(true);
      setErrorMessage("Something went wrong.");
      // alert("RuntimeException: Unexcepted image format 5346346457457")
    });

    if (response?.data?.status === "200") {
      setUser([usertemplet]);
      setloaderBool((current) => false);
      setsuccessModal((current) => !current);
      settermsConditionBool((current) => !current);
      document.getElementById("cnicback0").files = null
      document.getElementById("cnicfront0").value = null
      document.getElementById("cnicback0").value = null
      document.getElementById("cnicfront0").files = null
      setTimeout(() => {
        setsuccessModal((current) => !current);
        navigate("/")

      }, 10000);
    } else {
      // alert(response?.data?.message)
      setloaderBool((current) => false);
      setimageSizeErrorModal(true);
      setErrorMessage("Something went wrong.");

    }
  };
  const [termsConditionBool, settermsConditionBool] = useState(false);

  const termConditionEvent = (e) => {
    // handleShow();
    if (!addUserValidation()) {
      settermsConditionBool((prev) => e.target.checked);
      if (e.target.checked) {
        window.open(baseurl + "" + termsConditionsUrl);
      }
    } else {
      setimageSizeErrorModal(true);
      setErrorMessage("All fields are mandatory");

    }


  };

  const acceptTermCondtionsProp = (e) => {
    settermsConditionBool((prev) => e);
  };
  const navigate = useNavigate();
  return (
    <div
      className="container bg-primary1"
      style={{ backgroundImage: `url(${img3})` }}
    >
      <div className="row">
        <div className="col-12 pt-5 pb-5">
          <a onClick={() => navigate(-1)}>
            <img src={img4} className="mt-3 position-absolute " alt="" />
          </a>
          <img src={img1} style={{ height: '60px' }} className="d-block m-auto" alt="" />
        </div>
      </div>

      <div className="row ">
        <div className="content w-100">
          <h2 className="mt-2 mb-4">
            You can Add {supcardObj.count} Supplementary Cards 
            {/* (
            {(supcardObj.count ? supcardObj.count : 0 - users.length) < 0
              ? 0
              : supcardObj.count - users.length}
            )             */}
            

          </h2>
          <form onSubmit={submitSupplementCard}>
            {users.map((user, index) => (
              <div className="loan-lists" key={index}>
                <div className="loan-list position-relative card1">
                  <div className="card-button-group">
                    <button
                      type="button"
                      className={`add-icon ${supcardObj.count !== users.length ? "pulse" : ""
                        }`}
                      onClick={adduser}
                      disabled={supcardObj.count === users.length ? true : false}
                    >
                      <img src={img2} className="d-block m-auto" alt="" />
                    </button>
                    {index !== 0 && (
                      <button
                        type="button"
                        onClick={() => removeUsers(index)}
                        // disabled={supcardObj.count == users.length ? true:false}
                        className={`add-icon ${supcardObj.count !== users.length ? "pulse" : ""
                          }`}
                      >
                        <img
                          src={removeImg}
                          className="d-block m-auto"
                          alt=""
                        />
                      </button>
                    )}
                  </div>
                  <div className="col-12 col-sm-6 mt-xs-10 form-group p-2">
                    <label className="mb-1" htmlFor="exampleFormControlInput1">Supplementary Card Holder's Name</label>
                    <input
                      className="form-control form-control-lg"
                      name="Name"
                      required
                      pattern="[A-Z a-z]{3,}"
                      type="text"
                      onChange={(e) => onChange(e, index)}
                      value={user.Name}
                    />
                  </div>
                  <div className="col-12 col-sm-6 mt-xs-10 form-group p-2">
                    <label className="mb-1" htmlFor="exampleFormControlInput1">
                      Supplementary Card Holder's CNIC Number
                    </label>
                    <input
                      className="form-control form-control-lg"
                      required
                      placeholder="XXXXXXXXXXXXX"
                      name="cnic"
                      pattern="[0-9]{13}"
                      onChange={(e) => onChange(e, index)}
                      value={user.cnic}
                      type="tel"
                    />
                  </div>


                  <div className="col-12 col-sm-6 mt-xs-10 form-group p-2">
                    <div className="form-group  mb-0">
                      <label className="mb-1" htmlFor={"cnicfront" + index}>Supplementary Card Holder's CNIC Front</label>
                      <input
                        type="file"
                        className="form-control-file"
                        required
                        accept="image/png, image/jpg, image/jpeg, .pdf"
                        name="cnicfront"
                        ref={cnicFrontRef}
                        onChange={(e) => onChange(e, index)}
                        id={"cnicfront" + index}
                      />

                    </div>
                  </div>
                  <div className="col-12 col-sm-6 mt-xs-10 p-2 form-group  ">
                    <div className="form-group mb-0">
                      <label className="mb-1" htmlFor={"cnicback" + index}>Supplementary Card Holder's CNIC Back</label>
                      <input
                        type="file"
                        className="form-control-file"
                        required
                        accept="image/png, image/jpg, image/jpeg, .pdf"
                        name="cnicback"
                        onChange={(e) => onChange(e, index)}
                        ref={cnicBackRef}
                        // value={user.cnicback}
                        id={"cnicback" + index}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 mt-xs-10 form-group p-2">
                    <label className="mb-1" htmlFor="exampleFormControlInput1">Relationship with Primary Applicant</label>
                    <FormSelect onChange={(e) => onChange(e, index)}
                      name="relationshipWithPrimaryApplicant"
                      value={user.relationshipWithPrimaryApplicant}
                      required
                    >
                      <option value="">Select</option>

                      {relationwithApplicant.map((optionItem, optionIndex) =>
                        <option key={optionIndex} value={optionItem.key}>{optionItem.value}</option>
                      )}
                    </FormSelect>

                  </div>
                  <div className="col-12 col-sm-6 mt-xs-10 form-group p-2">
                    <label className="mb-1" htmlFor="exampleFormControlInput1">
                      Supplementary Card Limit (%)
                    </label>
                    <FormSelect name="cardLimitPercentage" onChange={(e) => onChange(e, index)}
                      value={user.cardLimitPercentage}
                      required
                    >
                      <option value="">Select</option>
                      {cardlimitpercent.map((optionItem, optionIndex) =>
                        <option key={optionIndex} value={optionItem.key}>{optionItem.value}</option>
                      )}

                    </FormSelect>

                  </div>
                </div>
              </div>
            ))}
            <Form.Check
              type={"checkbox"}
              checked={termsConditionBool}
              label={`Terms and Conditions`}
              value={termsConditionBool}
              onChange={(e) => termConditionEvent(e)}
            />

            <div className=" text-center mt-4">
              <button
                type="submit"
                className="btn btn-primary btn-lg pl-5 pr-5 submit-btn "
                disabled={loaderBool || !termsConditionBool ? true : false}
              >
                Submit{" "}
                {loaderBool && (
                  <Spinner
                    style={{ marginLeft: "10px" }}
                    animation="border"
                    role="status"
                    variant="light"
                  ></Spinner>
                )}
              </button>
            </div>
          </form>

          <TermsConditionModal
            show={show}
            handleClose={handleClose}
            acceptTermCondtionsProp={acceptTermCondtionsProp}
          />

          <Modal show={successModal} centered>
            <Modal.Body>
              <div className="success-Message">
                <img src={success} alt="" />
                <div>
                  <b className="text-success">Thank you!</b> for your submission. We are very happy to welcome your family into the exciting world of JS Credit Cards! You will receive an update within 5 working days.
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <ImageErrorModal
        show={imageSizeErrorModal}
        handleClose={handleImageErrorModalClose}
        ErrorMessage={ErrorMessage}
      />
    </div>
  );
};
